import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import useApi from "../../../../utils/api";
import { formatTimeSheetParams } from "../../../TimeSheet/api/helpers";
import { getToastErrorMessage } from "../../../../utils/helpers/errors";

const downloadFile = (response: any) => {
    const disposition = response?.headers?.["content-disposition"];
    let filename = "schedule.xlsx";
    if (disposition) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match?.[1]) {
            filename = match[1];
        }
    }

    const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

export const useExportScheduleQuery = () => {
    const { t } = useTranslation();
    const { call } = useApi();

    const exportScheduleMutation = useMutation({
        mutationFn: async (filters: Object) => {
            const res = await call({
                url: "/export/schedule",
                params: formatTimeSheetParams(filters as any),
                // headers: { "Content-Type": "Content-Disposition" },
                responseType: "arraybuffer",
            }, true);

            downloadFile(res);
            return res;
        },
        onMutate: () => toast.loading(t("downloading")),
        onSuccess: (_data, _vars, toastId) => {
            toast.dismiss(toastId);
            toast.success(t("schedule-exported-successfully"));
        },
        onError: (err, _vars, toastId) => {
            toast.dismiss(toastId);
            toast.error(getToastErrorMessage(err));
        },
    });

    return exportScheduleMutation;
}